import { cn } from './listingCardUtils.js';

export default function ListingCardDescription({ listing, show = {}, variant = 'content' }) {
  if (!show.description || !listing.description) return null;

  return (
    <p className={cn(
      'text-sm',
      variant === 'directory' ? 'line-clamp-3' : 'line-clamp-2',
      variant === 'hero' ? 'text-white/80' : 'text-slate-600',
    )}>
      {listing.description}
    </p>
  );
}
